let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '注册数',
        props: 'registCountAll',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩到家APP桩注册数',
        props: 'registCountZdjApp',
        minWidth: 180,
    },
    {
        label: '桩到家APP桩注册占比',
        props: 'registRatioZdjApp',
        minWidth: 200,
    },
    {
        label: '桩到家APP环比',
        props: 'yoyZdjApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdjApp = String(row.yoyZdjApp)
            if(row.yoyZdjApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdjApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdjApp.indexOf('-')>-1) {
                console.log(row.yoyZdjApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdjApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdjApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩到家APP增长量',
        props: 'increaseZdjApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdjApp = String(row.increaseZdjApp)
            if(row.increaseZdjApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdjApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdjApp.indexOf('-')>-1) {
                console.log(row.increaseZdjApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdjApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdjApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达APP桩注册数',
        props: 'registCountZdApp',
        minWidth: 180,
    },
    {
        label: '挚达APP桩注册占比',
        props: 'registRatioZdApp',
        minWidth: 200,
    },
    {
        label: '挚达APP环比',
        props: 'yoyZdApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdApp = String(row.yoyZdApp)
            if(row.yoyZdApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdApp.indexOf('-')>-1) {
                console.log(row.yoyZdApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达APP增长量',
        props: 'increaseZdApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdApp = String(row.increaseZdApp)
            if(row.increaseZdApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdApp.indexOf('-')>-1) {
                console.log(row.increaseZdApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达支付宝小程序APP桩注册数',
        props: 'registCountZdAli',
        minWidth: 180,
    },
    {
        label: '挚达支付宝小程序APP桩注册占比',
        props: 'registRatioZdAli',
        minWidth: 200,
    },
    {
        label: '挚达支付宝小程序APP环比',
        props: 'yoyZdAli',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdAli = String(row.yoyZdAli)
            if(row.yoyZdAli.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdAli.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdAli.indexOf('-')>-1) {
                console.log(row.yoyZdAli.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdAli.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdAli*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达支付宝小程序APP增长量',
        props: 'increaseZdAli',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdAli = String(row.increaseZdAli)
            if(row.increaseZdAli.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdAli.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdAli.indexOf('-')>-1) {
                console.log(row.increaseZdAli.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdAli.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdAli*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达微信小程序桩注册数',
        props: 'registCountZdWeChat',
        minWidth: 180,
    },
    {
        label: '挚达微信小程序桩注册占比',
        props: 'registRatioZdWeChat',
        minWidth: 200,
    },
    {
        label: '挚达微信小程序环比',
        props: 'yoyZdWeChat',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdWeChat = String(row.yoyZdWeChat)
            if(row.yoyZdWeChat.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdWeChat.indexOf('-')>-1) {
                console.log(row.yoyZdWeChat.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdWeChat*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达微信小程序增长量',
        props: 'increaseZdWeChat',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdWeChat = String(row.increaseZdWeChat)
            if(row.increaseZdWeChat.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdWeChat.indexOf('-')>-1) {
                console.log(row.increaseZdWeChat.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdWeChat*100).toFixed(2)+'%'
            }
        }
    },
];
pageConfig.listColumns1 = [
    
    {
        label: '统计日期',
        props: 'statisDate',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '访问量',
        props: 'dpvCountAll',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '环比',
        props: 'yoyAll',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyAll = String(row.yoyAll)
            if(row.yoyAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyAll.indexOf('-')>-1) {
                console.log(row.yoyAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseAll',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseAll = String(row.increaseAll)
            if(row.increaseAll.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseAll.indexOf('-')>-1) {
                console.log(row.increaseAll.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseAll.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseAll*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩到家APP桩访问数',
        props: 'traceCountZdjApp',
        minWidth: 180,
    },
    {
        label: '桩到家APP桩访问占比',
        props: 'traceRatioZdjApp',
        minWidth: 200,
    },
    {
        label: '桩到家APP环比',
        props: 'yoyZdjApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdjApp = String(row.yoyZdjApp)
            if(row.yoyZdjApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdjApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdjApp.indexOf('-')>-1) {
                console.log(row.yoyZdjApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdjApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdjApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '桩到家APP增长量',
        props: 'increaseZdjApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdjApp = String(row.increaseZdjApp)
            if(row.increaseZdjApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdjApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdjApp.indexOf('-')>-1) {
                console.log(row.increaseZdjApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdjApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdjApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达APP桩访问数',
        props: 'dpvCountZdApp',
        minWidth: 180,
    },
    
    {
        label: '挚达APP环比',
        props: 'yoyZdApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdApp = String(row.yoyZdApp)
            if(row.yoyZdApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdApp.indexOf('-')>-1) {
                console.log(row.yoyZdApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达APP增长量',
        props: 'increaseZdApp',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdApp = String(row.increaseZdApp)
            if(row.increaseZdApp.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdApp.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdApp.indexOf('-')>-1) {
                console.log(row.increaseZdApp.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdApp.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdApp*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '支付宝小程序APP桩访问数',
        props: 'dpvCountZdAli',
        minWidth: 180,
    },
    {
        label: '支付宝小程序APP环比',
        props: 'yoyZdAli',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdAli = String(row.yoyZdAli)
            if(row.yoyZdAli.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdAli.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdAli.indexOf('-')>-1) {
                console.log(row.yoyZdAli.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdAli.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdAli*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '支付宝小程序APP增长量',
        props: 'increaseZdAli',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdAli = String(row.increaseZdAli)
            if(row.increaseZdAli.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdAli.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdAli.indexOf('-')>-1) {
                console.log(row.increaseZdAli.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdAli.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdAli*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '挚达微信小程序桩访问数',
        props: 'dpvCountZdWeChat',
        minWidth: 180,
    },
    {
        label: '与昨日环比',
        props: 'yoyZdWeChat',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.yoyZdWeChat = String(row.yoyZdWeChat)
            if(row.yoyZdWeChat.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else if(row.yoyZdWeChat.indexOf('-')>-1) {
                console.log(row.yoyZdWeChat.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.yoyZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.yoyZdWeChat*100).toFixed(2)+'%'
            }
        }
    },
    {
        label: '增长量',
        props: 'increaseZdWeChat',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            row.increaseZdWeChat = String(row.increaseZdWeChat)
            if(row.increaseZdWeChat.indexOf('+')>-1){
                return `<i class="el-icon-top" style="color:red;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else if(row.increaseZdWeChat.indexOf('-')>-1) {
                console.log(row.increaseZdWeChat.indexOf('-'));
                return `<i class="el-icon-bottom" style="color:green;font-size:20px;font-weight:900;"></i>`+Number(row.increaseZdWeChat.substring(1)*100).toFixed(2)+'%'
            }else{
                return Number(row.increaseZdWeChat*100).toFixed(2)+'%'
            }
        }
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户注册报表'
    }, 
    {
        type: 'title',
        name: '用户访问量列表'
    }, 
];
pageConfig.listBreadCrumb1 = [
    {
        type: 'title',
        name: '首页',
    }, {
        type: 'title',
        name: '运营分析',
    },
        {
        type: 'title',
        name: '用户数据信息',
    },
    {
        type: 'title',
        name: '用户注册报表'
    }, 
    {
        type: 'title',
        name: '用户注册数列表'
    }, 
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};



export default pageConfig;
